import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  addTeamLeaderRequest,
  addTeamLeaderSuccess,
  addTeamLeaderFailure,
} from '../reducers/addTeamLeader';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api`;

function* addTeamLeaderFunctionAxios() {
  const state = yield select(fullState => fullState);
  const {
    user: { userId },
    token,
  } = state.loginReducer;
  const leaderId = state.messageContentReducer.message.data.sender.id;

  const response = yield call(() =>
    axios({
      method: 'post',
      url: `${API}/user/${userId}/lead/${leaderId}`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
      credentials: 'same-origin',
      data: {
        userId,
        leaderId,
      },
    }),
  );
  return response;
}

function* workerAddTeamLeaderSaga() {
  try {
    const response = yield call(addTeamLeaderFunctionAxios);
    const responseFromAddTeamLeader = response.data;
    if (response.status === 200) {
      yield put(addTeamLeaderSuccess(responseFromAddTeamLeader));
    }
    if (response.status === 201) {
      yield put(addTeamLeaderFailure(responseFromAddTeamLeader.message));
    }
  } catch (error) {
    yield put(addTeamLeaderFailure(error.message));
  }
}

export function* watcherAddTeamLeaderSaga() {
  yield takeLatest(addTeamLeaderRequest().type, workerAddTeamLeaderSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/post_addTeamLeader.js